import React, { useEffect } from 'react';
import BookendRow from '../BookendRow';

function ExpandedProductDetails(props) {

    useEffect(() => {
      props.getProductDetails(props.productId);
    }, [props.productId]);

    if (Object.keys(props.product).length > 0 && !props.loading) {

      const references = props.product.references ? props.product.references : [];
      let equipment = props.product.equipment ? props.product.equipment : [];

      let cutoffMessage = '';
      if (props.product.equipment.length > 20) {
        equipment = equipment.slice(0, 20);
        cutoffMessage = '(first 20)';
      }

      return (
        <div style={{marginTop: 10}}>
          <BookendRow left='Cataloging Status:' right={<strong>{props.product.product_cataloging_status}</strong>} />
          <BookendRow left='Weight:' right={props.product.product_weight + ' lbs'} />
          <BookendRow left='QoH:' right={props.product.qty.qoh} />
          <BookendRow left='Available:' right={props.product.qty.available} />
          {props.product.product_alias_for > 0 ? 
            <BookendRow left='Child of: ' right={<a href={'/cart/ViewItem/' + props.product.product_alias_for}>{props.product.product_alias_for}</a>} />
          : null }

          <div style={{fontWeight: 'bold', marginTop: 5}}>References manufacturer P/Ns:</div>
          {references.map((reference, key) => {
            return <p key={key}>{reference.manufacturer_name} - <strong>{reference.manufacturer_part_number}</strong></p>;
          })}

          <div style={{fontWeight: 'bold', marginTop: 5}}>Listed on equipment: <span style={{fontWeight: 'normal'}}>{cutoffMessage}</span></div>
          {equipment.map((equipment, key) => {
            return <p key={key}>{equipment.brand_name} - <a href={'/equipment/Select/' + equipment.equipment_id}>{equipment.equipment_name}</a></p>; 
          })}
        </div>
      );
    } else {
      return null;
    }
  }

export default ExpandedProductDetails;